import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { MotorcycleProductIntroFormValues } from "../motorcycleInterface";

export const validationSchema =
  (): Yup.ObjectSchema<MotorcycleProductIntroFormValues> => {
    const { getText } = TextManager;

    return Yup.object().shape({
      year: Yup.string().required(getText("motorcycleform.validation.year")),
      brand: Yup.string().required(getText("motorcycleform.validation.brand")),
      model: Yup.string().required(getText("motorcycleform.validation.model")),
      bonus: Yup.string().required(getText("motorcycleform.validation.bonus")),
    });
  };
